import styled from 'styled-components';
import { StyledInput, fadeDuration, } from '../GenericOption/GenericOption.styles';
export const StyledRadioButton = styled(StyledInput).attrs({ type: 'radio' }) `
  border-radius: 50%;

  /* Dot */
  &::before {
    display: block;
    width: 8px;
    height: 8px;

    background-color: ${(props) => props.theme.colors.form.muted.tertiary};
    border-radius: 50%;
    transform: scale(1);
    transform-origin: 50%;

    transition: ${fadeDuration} ${(props) => props.theme.easing};
    transition-property: transform background-color;

    content: '';
  }

  /* Dot checked */
  &:checked::before {
    background-color: ${(props) => props.theme.colors.form.primary};
    transform: scale(1.5);
  }

  /* Dot readonly */
  &[readonly]::before {
    background-color: ${(props) => props.theme.colors.form.muted.tertiary};
  }

  /* Dot readonly */
  &[readonly]:checked::before {
    background-color: ${(props) => props.theme.colors.form.primary};
  }

  /* Dot invalid */
  &:invalid::before {
    ${(props) => props.invalid &&
    `background-color: ${props.theme.colors.form.muted.tertiary};`}
  }

  /* Dot disabled */
  &:disabled::before {
    background-color: ${(props) => props.theme.colors.form.muted.tertiary};
  }

  /* Dot disabled checked */
  &:disabled:checked::before {
    background-color: ${(props) => props.theme.colors.form.muted.secondary};
  }

  /* Dot invalid */
  &:invalid:checked::before {
    ${(props) => props.invalid && `background-color: ${props.theme.colors.form.error};`}
  }

  /* Dot hover */
  &:enabled:not([readonly]):not(:checked):hover::before {
    background-color: ${(props) => props.theme.colors.form.muted.tertiary};
    transform: scale(1.25);
  }

  /* Dot checked:hover */
  &:enabled:not([readonly]):checked:hover::before {
    transform: scale(1.25);
  }

  /* Dot checked:hover */
  &:enabled:not([readonly]):checked:valid:hover::before {
    background-color: ${(props) => props.theme.colors.form.primary};
  }
`;
//# sourceMappingURL=RadioButton.styles.js.map